import { render, staticRenderFns } from "./UserOrgEdit.vue?vue&type=template&id=35c74a98&scoped=true"
import script from "./UserOrgEdit.vue?vue&type=script&lang=js"
export * from "./UserOrgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c74a98",
  null
  
)

export default component.exports